import moduleManager from './ModuleManager.js'
import './GameModule.js'
import './RoutingModule.js'

// Export the module manager for use in components
export default moduleManager

// Export individual modules for direct access
export { default as gameModule } from './GameModule.js'
export { default as routingModule } from './RoutingModule.js' 